<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('yearlySoldBySaleType.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('yearlySoldBySaleType.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('yearlySoldBySaleType.criteria') }}</legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlySoldBySaleType.date')
                      }}</label>
                      <a-range-picker
                        style="width: 100%"
                        :mode="mode"
                        format="MM-YYYY"
                        v-model="month_range"
                        valueFormat="MM-YYYY"
                        @panelChange="handlePanelChange"
                        @change="dateChange"
                      />
                      <div class="validate" v-if="errors.has('month_range')">
                        {{ errors.first('month_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('yearlySoldBySaleType.branch') }}</label>
                      <a-select
                        style="width: 100%; font-size: 15px"
                        mode="multiple"
                        placeholder="All"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.branch_id"
                        :options="branchList"
                        @change="onChangeBranch"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>{{ $t('yearlySoldBySaleType.location') }}</label>

                        <a-select
                          v-model="model.location_id"
                          mode="multiple"
                          :defaultActiveFirstOption="true"
                          showSearch
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          :options="locations"
                          :placeholder="$t('all')"
                          class="ts-w-full"
                        ></a-select>
                        <div class="validate" v-if="errors.has('location_id')">
                          {{ errors.first('location_id') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>
                        {{ $t('yearlySoldBySaleType.category') }}
                      </label>
                      <a-select
                        style="width: 100%"
                        mode="multiple"
                        placeholder="All"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.category_id"
                        :options="categories"
                        @change="fetchProductGroup"
                      ></a-select>
                      <div class="validate" v-if="errors.has('category_id')">
                        {{ errors.first('category_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>
                        {{ $t('yearlySoldBySaleType.productGroup') }}
                      </label>
                      <a-select
                        style="width: 100%"
                        mode="multiple"
                        placeholder="All"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.product_group_id"
                        :options="productGroups"
                        @change="fetchProduct()"
                      ></a-select>
                      <div class="validate" v-if="errors.has('product_id')">
                        {{ errors.first('product_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>
                        {{ $t('yearlySoldBySaleType.product') }}
                      </label>
                      <a-select
                        style="width: 100%"
                        mode="multiple"
                        placeholder="All"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.product_id"
                        :options="products"
                        @search="handleSearchProduct"
                      ></a-select>
                      <div class="validate" v-if="errors.has('product_id')">
                        {{ errors.first('product_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label>{{ $t('yearlySoldBySaleType.saleType') }}</label>
                      <a-select
                        style="width: 100%"
                        v-model="model.sale_type"
                        mode="multiple"
                        :options="posType"
                        placeholder="All"
                      >
                      </a-select>
                      <div class="validate" v-if="errors.has('type')">
                        {{ errors.first('type') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('yearlySoldBySaleType.type')
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model="model.is_amount"
                        :options="amountType"
                      >
                      </a-select>
                      <div class="validate" v-if="errors.has('type')">
                        {{ errors.first('type') }}
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="model.is_amount && false">
                    <div class="form-group required">
                      <div class="col-md-12">
                        <a-radio-group v-model="model.is_amount_currency">
                          <a-radio value="USD">USD</a-radio>
                          <a-radio value="THB">THB</a-radio>
                          <a-radio value="KHR">KHR</a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <a-radio-group
                      v-model="model.report_type"
                      class="col-md-12"
                    >
                      <a-radio-button value="1" class="col-md-6"
                        >Details</a-radio-button
                      >
                      <a-radio-button value="2" class="col-md-6"
                        >Summary</a-radio-button
                      >
                    </a-radio-group>
                  </div>
                  <div class="row">
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        outline
                        color="success"
                        @click.prevent="exportExcel"
                        :waiting="exporting"
                        ><i class="fas fa-file-excel"></i>
                        {{ $t('excel') }}</ts-button
                      >
                    </div>
                    <div class="col-md-6 text-right">
                      <ts-button
                        class="btn-block"
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        ><i class="fas fa-file-pdf text-red"></i>
                        {{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('yearlySoldBySaleType.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import * as FileDownload from 'downloadjs'
import { trim, debounce } from 'lodash'

export default {
  name: 'yearlySoldBySaleType',
  data () {
    return {
      loading: false,
      waiting: false,
      exporting: false,
      src: null,
      errors: new Errors(),
      branchList: [],
      categories: [],
      products: [],
      productGroups: [],
      locations: [],
      mode: ['month', 'month'],
      month_range: [moment().startOf('year'), moment().endOf('year')],
      model: {
        branch_id: undefined,
        location_id: undefined,
        category_id: undefined,
        pro_group_id: undefined,
        product_id: undefined,
        amount: undefined,
        sale_type: undefined,
        is_amount: 'true',
        is_amount_currency: '',
        report_type: '1',
        month_range: [
          moment().startOf('year').format('MM-YYYY'),
          moment().endOf('year').format('MM-YYYY')
        ]
      }
    }
  },
  computed: {
    posType () {
      return [
        { value: '1', label: 'Retail sale' },
        { value: '2', label: 'Whole sale' },
        { value: '3', label: 'Borrowing' }
      ]
    },
    amountType () {
      return [
        { value: 'true', label: 'Amount' },
        { value: 'false', label: 'Qty' }
      ]
    }
  },
  created () {
    this.model.is_amount_currency = this.$store.state.authUser.sys_setting.default_currency
    this.fetchData()
  },
  methods: {
    ...mapActions('report/finance', ['yearlySoldBySaleType']),
    handleSearchProduct: debounce(async function (value) {
      if (!value) return false
      this.fetchProduct(value)
    }, 500),
    handlePanelChange (value, mode) {
      this.month_range = value
      this.model.month_range[0] = moment(value[0]).format('MM-YYYY')
      this.model.month_range[1] = moment(value[1]).format('MM-YYYY')
      this.mode = [
        mode[0] === 'date' ? 'month' : mode[0],
        mode[1] === 'date' ? 'month' : mode[1]
      ]
    },
    dateChange (value) {
      this.month_range = value
      this.model.month_range[0] = value[0]
      this.model.month_range[1] = value[1]
    },
    async fetchData () {
      this.loading = true
      await this.$store
        .dispatch('security/user/getBranchAssigned')
        .then(response => {
          this.branchList = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
      await this.$store
        .dispatch('report/resource/productCategory')
        .then(response => {
          this.categories = response.data.map(el => ({
            value: el.category_id,
            label: el.category_name_en
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeBranch() {
      this.locationLoading = true
      this.locations = []
      this.model.location_id = undefined
      this.$store
        .dispatch('report/resource/getLocation', {
          branch_id: this.model.branch_id,
        })
        .then((response) => {
          this.locations = response.data.map((el) => ({
            value: el.location_id,
            label: el.location_name_en,
          }))
        })
        .finally(() => {
          this.locationLoading = false
        })
    },
    fetchProductGroup () {
      this.model.product_group_id = undefined
      this.model.product_id = undefined
      this.loading = true
      this.$store
        .dispatch('report/resource/productGroup', {
          filter: {
            category_id: _.join(this.model.category_id, ',')
          }
        })
        .then(response => {
          this.productGroups = response.data.map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
          this.fetchProduct()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchProduct (value) {
      this.model.product_id = undefined
      this.loading = true
      this.$store
        .dispatch('report/resource/productProfileLocation', {
          filter: {
            search: value,
            pro_group_id: _.join(this.model.product_group_id, ','),
            category_id: _.join(this.model.category_id, ',')
          }
        })
        .then(response => {
          this.products = response.data.map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.yearlySoldBySaleType(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel () {
      this.exporting = true
      this.errors = new Errors()
      this.$store
        .dispatch('report/finance/yearlySoldBySaleTypeExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  }
}
</script>
